import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Divider,
  FileInput,
  Group,
  LoadingOverlay,
  Modal,
  Select,
  Tabs,
  TagsInput,
  Text,
  TextInput,
  Textarea,
  rem,
  useCombobox,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconFileCv } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import ImageShow from "../../../_base/component/_image";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import {
  formatDateToString,
  formatFormData,
} from "../../../_base/helper/FunctionHelper";
import Repository from "../../../_base/helper/HttpHelper";
import { datavisibleType } from "../../../_data-fix/datavisibleType";
import { createItemCategory } from "../../../api/ApiMegaMenu";
import { getDataBrand } from "../../../api/ApiSell";
import QuillEditor from "../../../common/QuillEditor";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { Brand } from "../../../model/ProductList";
import { CategoryTree } from "../../../model/TblCategoryCommand";
import {
  TblCategoryModel,
  listTblCategoryImage,
} from "../../../model/TblCategoryModel";
import { _validate } from "../../../validate/TblCategoryModelValidate";
import { slugify } from "@elastic/eui";
import { uploadImageAddFolder } from "../../../api/ApiMore";

const CreateView = function ({
  onClose,
  load,
  fetchData,
}: {
  onClose: any;
  load: number;
  fetchData?: () => void;
}) {
  const entity: TblCategoryModel = {
    id: 0,
    categoryCode: null,
    categoryName: "",
    isBuildPc: "N",
    isMegaMenu: "N",
    idParent: null,
    description: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    lastUpdateLogin: null,
    orgId: null,
    categoryType: null,
    content: null,
    tags: null,
    imageIcon: null,
    imageOwner: null,
    priceRange: null,
    visibleType: null,
    fixedContent: null,
    orderedNumber: null,
    urlRedirect: null,
    templateFile: null,
    visibleItemQty: null,
    urlCanonicalForSeo: null,
    linkForSeo: null,
    idexForSeo: null,
    enableChangeLink: null,
    metaTitle: null,
    metaKeyword: null,
    metaDescription: null,
    itemCount: 0,
    tblCategoryModels: [],
    categoryTreeModels: [],
    tblCategoryAttributeModel: null,
    tblCategoryImageModels: null,
    listTblCategoryImage: null,
    listTblCategoryAttribute: [],
    status: null,
    priorityStatus: null,
    brandIds: [],
    isDisplay: null, //Dùng để hiển thị danh mục này  trong session sản phẩm trong homepage
    sequenceNumber: null, //Số thứ tự hiển thị trong session trong homepage
    imgurl: null, //Ảnh icon của danh mục
    imgBig: null, //Ảnh đại diện của danh mục
  };
  const form = useForm<TblCategoryModel>({
    initialValues: {
      ...entity,
    },

    validate: _validate,
  });

  //
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [isImageChange, setIsImageChange] = useState<boolean[]>([]);
  const [isCategoryImageChange, setIsCategoryImageChange] = useState(false);
  const [dataBrand, setDataBrand] = useState<Brand[]>([]);
  const [previewImgUrl, setPreviewImgUrl] = useState<string | null>(null);
  const [previewImgBig, setPreviewImgBig] = useState<string | null>(null);
  const [loadingImageUrl, setLoadingImageUrl] = useState<number>(0);
  const [loadingImageBig, setLoadingImageBig] = useState<number>(0);
  const [selectedImgUrl, setSelectedImgUrl] = useState<File | null>(null);
  const [selectedImgBig, setSelectedImgBig] = useState<File | null>(null);
  const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
  const [modalOpened, setModalOpened] = useState(false);

  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const [Urlcanonical, setUrlcanonical] = useState<string>(
    `Url canonical ${0} ký tự,${0} từ :`
  );
  const [MetaKeywords, setMetaKeywords] = useState<string>(
    `Meta Keywords ${0} ký tự,${0} từ :`
  );
  const [MetaDescription, setMetaDescription] = useState<string>(
    `Meta Description ${0} ký tự,${0} từ :`
  );
  const [MetaTitle, setMetaTitle] = useState<string>(
    `Meta Title ${0} ký tự,${0} từ :`
  );
  const [modalContent, setModalContent] = useState("");
  const [modalFixedContent, setModalFixedContent] = useState("");

  const [valueTags, setValueTags] = useState<string[]>([]);

  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
    onDropdownOpen: () => combobox.updateSelectedOptionIndex("active"),
  });
  const [dataDrop, setDataDrop] = useState<ComboboxItem[]>([]);
  const [dataCategory, setDataCategory] = useState<CategoryTree[]>([]);
  const _datavisibleType = datavisibleType;

  const apiCreate = async (data: any) => {
    open();

    data.tags = valueTags.join(",");

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === "listTblCategoryImage") {
        const listTblCategoryImage = data[key];
        listTblCategoryImage?.forEach((item: any, index: number) => {
          Object.keys(item).forEach((itemKey) => {
            const formDataKey = `listTblCategoryImage[${index}].${itemKey}`;
            if (item[itemKey]) {
              formData.append(formDataKey, item[itemKey]);
            }
          });
        });
      } else if (key === "brandIds") {
        const brandIds = data[key];
        brandIds.forEach((item: any, index: number) => {
          const formDataKey = `brandIds[${index}]`;
          if (item !== null && item !== undefined) {
            if (item instanceof Object && !(item instanceof File)) {
              formData.append(formDataKey, item.id);
            } else formData.append(formDataKey, item);
          }
        });
      } else if (Array.isArray(data[key])) {
        data[key].forEach((item: any, index: any) => {
          formatFormData(item, formData, `${key}[${index}]`);
        });
      } else if (data[key] instanceof Object && !(data[key] instanceof File)) {
        formatFormData(data[key], formData, key);
      } else {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
    });
    // Thêm file thực tế vào formData
    if (previewImgUrl && previewImgUrl.length > 0) {
      formData.set("imgurl", previewImgUrl);
    }
    if (previewImgBig && previewImgBig.length > 0) {
      formData.set("imgBig", previewImgBig);
    }
    let callapi = await createItemCategory(formData);
    if (!isNullOrUndefined(callapi) && callapi?.success) {
      if (fetchData) {
        await fetchData();
      }
      onClose(load + 1);
      NotificationExtension.Success("Tạo mới thành công !");
      modals.closeAll();
    } else if (callapi != null)
      NotificationExtension.Fails("Tạo mới thất bại !");
    close();
  };
  function GetUrlcanonical(url: string) {
    const one = url.split(" ").length;
    setUrlcanonical(`Url canonical ${one} ký tự,${url.length} từ :`);
  }
  function GetMetaKeywords(url: string) {
    const one = url.split(" ").length;
    setMetaKeywords(`MetaKeywords ${one} ký tự,${url.length} từ :`);
  }
  function GetMetaDescription(url: string) {
    const one = url.split(" ").length;
    setMetaDescription(`MetaDescription ${one} ký tự,${url.length} từ :`);
  }
  function GetMetaTitle(url: string) {
    const one = url.split(" ").length;
    setMetaTitle(`MetaTitle ${one} ký tự,${url.length} từ :`);
  }
  //
  const handleAddCategoryImage = (
    dataCategoryImage: listTblCategoryImage[],
    isImageChange: boolean[]
  ) => {
    NotificationExtension.Success("Thêm dữ liệu ảnh thành công");
    setIsImageChange(isImageChange);
    setIsCategoryImageChange(true);
    form.values.listTblCategoryImage = dataCategoryImage;
  };

  const handleSubmitForm = (dataSubmit: TblCategoryModel) => {
    console.log("dataSubmit", dataSubmit);
    const {
      tblCategoryImageModels,
      listTblCategoryImage,
      tblCategoryModels,
      ...restGroup
    } = dataSubmit;
    var dataImage: listTblCategoryImage[] = [
      {
        imageCode: null,
        imageName: null,
        description: null,
        image: null,
        status: null,
        title: null,
        linkUrl: null,
        imageGroup: null,
        orgId: null,
        categoryId: null,
        createdBy: null,
        lastUpdateDate: null,
        lastUpdatedBy: null,
        lastUpdateLogin: null,
      },
    ];
    if (isCategoryImageChange) {
      dataImage = (listTblCategoryImage || [])?.map((item, index) => {
        const { image, ...restGroup } = item;
        return isImageChange[index] ? item : { ...restGroup, image: null };
      });
    } else {
      dataImage = (listTblCategoryImage || [])?.map((item) => {
        return { ...item, image: null };
      });
    }
    console.log("restGroup", restGroup);
    // Loại bỏ imgurl và imgBig khỏi restGroup trước khi submit
    const { imgurl, imgBig, ...restWithoutImg } = restGroup;
    // Truyền file thực tế vào 2 trường imgurl, imgBig
    apiCreate({
      ...restWithoutImg,
      requestPath:
        dataSubmit?.requestPath && !dataSubmit?.requestPath.startsWith("/")
          ? "/" + dataSubmit?.requestPath
          : dataSubmit?.requestPath,
      listTblCategoryImage: dataImage,
      imgurl: previewImgUrl,
      imgBig: previewImgBig,
      content: modalContent,
      fixedContent: modalFixedContent,
    });
  };

  const handleConverDataOption = (data: any[]) => {
    return data?.map((item: any) => {
      return {
        value: String(item.id),
        label: item.name,
      };
    });
  };

  function removeVietnameseTones(str: string) {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D")
      .replace(/\//g, "-")
      .replace(/[\*\,%]/g, "");
  }

  const handleUploadImage = async (files: File[] | File, folder: string) => {
    if (!files) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    }

    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (fileArray.length === 0) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    } else {
      const res = await uploadImageAddFolder(
        `${
          folder === "icon"
            ? "cdn/Media/Image/CategoryIcon"
            : folder === "avatar"
            ? "cdn/Media/Image/CategoryOwner"
            : ""
        }/${newDate}`,
        fileArray
      );

      if (res && res.success) {
        const data = res?.data[0]?.url;
        NotificationExtension.Success("Tải ảnh lên thành công !");
        if (folder === "icon") {
          setPreviewImgUrl(data);
          setLoadingImageUrl((prev) => prev + 1);
        } else {
          setPreviewImgBig(data);
          setLoadingImageBig((prev) => prev + 1);
        }
      } else {
        NotificationExtension.Fails(res.message);
        if (folder === "icon") {
          setPreviewImgUrl(null);
        } else {
          setPreviewImgBig(null);
        }
      }
    }
  };

  //
  useEffect(() => {
    const fetchDataProvince = async () => {
      open();
      const data = await getDataBrand();
      setDataBrand(data?.data.lists);
      close();
    };
    fetchDataProvince();
  }, []);

  useEffect(() => {
    const callDataCategoryTree = async () => {
      try {
        let urlSearch =
          API_ROUTE.GET_CATEGORY_TREE + `?IsTradeIn=N&Skip=0&Take=2000`;
        let callapi = await repository.get<MessageResponse<CategoryTree[]>>(
          urlSearch
        );
        if (
          isNullOrUndefined(callapi) ||
          isNullOrUndefinedArry(callapi?.data)
        ) {
          setDataCategory([]);
        } else {
          setDataCategory(callapi?.data ?? []);
        }
        return callapi?.data;
      } catch (error: any) {
        return null;
      } finally {
      }
    };
    callDataCategoryTree();
  }, []);

  useEffect(() => {
    const flattenCategoryTree = (categories: CategoryTree[], level = 0) => {
      let result: { value: string; label: string }[] = [];

      categories.forEach((category) => {
        result.push({
          value: category.id.toString(),
          label: `${"\u00A0\u00A0\u00A0\u00A0\u00A0 ".repeat(level)} - ${
            category.categoryName
          }`,
        });

        if (category.categoryChildModels.length > 0) {
          result = result.concat(
            flattenCategoryTree(category.categoryChildModels, level + 1)
          );
        }
      });

      return result;
    };

    const flattenedCategories = flattenCategoryTree(dataCategory);
    setDataDrop(flattenedCategories);
  }, [dataCategory]);

  useEffect(() => {
    const newValue = form.getValues()?.categoryName;
    const newValueUnicode = removeVietnameseTones(newValue);
    form.setValues({ requestPath: `/${slugify(newValueUnicode)}` });
  }, [form.getValues()?.categoryName]);
  //

  // Hàm xử lý khi chọn file ảnh icon
  // const handleImgUrlChange = (file: File | null) => {
  //   if (file) {
  //     setPreviewImgUrl(URL.createObjectURL(file));
  //     setSelectedImgUrl(file);
  //   } else {
  //     setPreviewImgUrl(null);
  //     setSelectedImgUrl(null);
  //   }
  // };

  // Hàm xử lý khi chọn file ảnh đại diện
  // const handleImgBigChange = (file: File | null) => {
  //   if (file) {
  //     setPreviewImgBig(URL.createObjectURL(file));
  //     setSelectedImgBig(file);
  //     // KHÔNG setFieldValue cho imgBig nữa
  //   } else {
  //     setPreviewImgBig(null);
  //     setSelectedImgBig(null);
  //   }
  // };

  const formCreate = (
    <>
      <Divider my="sm" />
      <Box className="flex-none" component="form" miw={600} mx="auto">
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" gap={"lg"} align="start">
          <TextInput
            label="Tên danh mục: "
            placeholder="Tên danh mục..."
            withAsterisk
            {...form.getInputProps("categoryName")}
          />
          <TextInput
            label="Mã danh mục: "
            placeholder="Mã danh mục..."
            // withAsterisk
            {...form.getInputProps("categoryCode")}
          />
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <Textarea
            label={Urlcanonical}
            placeholder="Url canonical..."
            autosize
            {...form.getInputProps("urlCanonicalForSeo")}
            onChange={(e) => {
              GetUrlcanonical(e.target.value);
              if (form.getInputProps(`urlCanonicalForSeo`).onChange)
                form.getInputProps(`urlCanonicalForSeo`).onChange(e);
            }}
            minRows={1}
            // withAsterisk
          />
          <TextInput
            label="URL"
            placeholder="Nhập URL"
            {...form.getInputProps("requestPath")}
          />
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <Select
            label={"Nổi bật"}
            placeholder={"Nhập trạng thái nổi bật"}
            withAsterisk
            mt="md"
            data={[
              { value: "Y", label: "Nổi bật" },
              { value: "N", label: "Không nổi bật" },
            ]}
            {...form.getInputProps("priorityStatus")}
          />
          <Select
            label={"Trạng thái"}
            placeholder={"Nhập trạng thái"}
            withAsterisk
            mt="md"
            data={[
              { value: "I", label: "Ẩn" },
              { value: "A", label: "Hiện" },
            ]}
            {...form.getInputProps("status")}
          />
        </Group>

        <Group grow wrap="nowrap" gap={"lg"}>
          <Select
            mt={"lg"}
            label="Là danh mục con của: "
            placeholder="Chọn danh mục cha..."
            data={dataDrop}
            searchable
            clearable
            nothingFoundMessage="Không có dữ liệu"
            {...form.getInputProps("idParent")}
            mb={"lg"}
          />
          <Select
            mt={"lg"}
            label="Loại nội dung hiển thị: "
            placeholder="Chọn loại nội dung hiển thị..."
            data={_datavisibleType}
            searchable
            withAsterisk
            {...form.getInputProps("visibleType")}
            mb={"lg"}
          />
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <Select
            label="Là danh mục sản phẩm hay danh mục SEO"
            placeholder="Chọn danh mục sản phẩm hay danh mục SEO"
            data={[
              { label: "Category", value: "Category" },
              { label: "SEO", value: "SEO" },
            ]}
            searchable
            withAsterisk
            {...form.getInputProps("categoryType")}
            mb={"lg"}
          />

          <>
            <Checkbox
              mt={"xs"}
              label="Dùng làm danh mục build pc"
              checked={form.values.isBuildPc === "Y" ? true : false}
              onChange={(e) => {
                form
                  .getInputProps("isBuildPc", { type: "checkbox" })
                  .onChange(e.target.checked ? "Y" : "N");
              }}
            />
            <Checkbox
              mt={"xs"}
              label="Dùng làm mega menu"
              checked={form.values.isMegaMenu === "Y" ? true : false}
              onChange={(e) => {
                form
                  .getInputProps("isMegaMenu", { type: "checkbox" })
                  .onChange(e.target.checked ? "Y" : "N");
              }}
            />
          </>
        </Group>
        <Group grow wrap="nowrap" gap={"lg"} align="center">
          <Select
            label={"Thay đổi liên kết"}
            placeholder={"Bật/Tắt"}
            data={[
              { value: "Y", label: "Bật" },
              { value: "N", label: "Tắt" },
            ]}
            {...form.getInputProps("enableChangeLink")}
          />
          <TextInput
            label="Số thứ tự hiển thị: "
            type="number"
            placeholder="Số thứ tự hiển thị..."
            {...form.getInputProps("sequenceNumber")}
          />
          <Checkbox
            mt={"xs"}
            label="Hiển thị danh mục này trong homepage"
            checked={form.values.isDisplay === true ? true : false}
            onChange={(e) => {
              form
                .getInputProps("isDisplay", { type: "checkbox" })
                .onChange(e.target.checked);
            }}
          />
        </Group>
        <Text size="sm" mt="sm" fw={500}>
          Mô tả (nếu có):
          {/* Thư viện ảnh Bạn cần tạo danh mục trước khi có thể
          upload ảnh */}
        </Text>
        {/* <QuillEditor
          toolbarId="t1"
          setValue={setModel}
          onChangeValue={(html: string) => (form.values.fixedContent = html)}
        /> */}
        <Textarea
          mt={"lg"}
          placeholder="Mã danh mục..."
          withAsterisk
          {...form.getInputProps("description")}
        />
        <TagsInput
          label="Từ khóa (tags, nếu có - nhập mỗi cụm từ 1 dòng)"
          placeholder="Từ khóa..."
          mt="lg"
          {...form.getInputProps("tags")}
          data={[]}
          value={valueTags}
          onChange={setValueTags}
        />

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Box>
            <FileInput
              leftSection={icon}
              label="Ảnh icon"
              placeholder="Chọn tệp..."
              accept="image/png,image/jpeg"
              leftSectionPointerEvents="none"
              value={selectedImgUrl}
              onChange={(e) => {
                setSelectedImgUrl(e);
                if (e) {
                  handleUploadImage(e, "icon");
                }
              }}
            />

            <Box
              mt="sm"
              style={{
                border: "2px dashed #e9ecef",
                borderRadius: "8px",
                padding: "12px",
                backgroundColor: "#f8f9fa",
                textAlign: "center",
              }}
            >
              <Text size="xs" c="dimmed" mb="xs">
                Ảnh icon hiện tại
              </Text>
              <Box
                style={{
                  borderRadius: "6px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  border: "1px solid #dee2e6",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: 140, // Cố định chiều cao và chiều rộng khung ảnh
                }}
              >
                {previewImgUrl ? (
                  <img
                    src={previewImgUrl}
                    alt="Preview Icon"
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      display: "block",
                      margin: "auto",
                      cursor: "pointer",
                    }}
                    onDoubleClick={() => {
                      setModalImageUrl(previewImgUrl);
                      setModalOpened(true);
                    }}
                  />
                ) : (
                  <ImageShow h={120} w={120} img={"#"} />
                )}
              </Box>
            </Box>
          </Box>

          <Box>
            <FileInput
              leftSection={icon}
              label="Ảnh đại diện"
              placeholder="Chọn tệp..."
              accept="image/png,image/jpeg"
              leftSectionPointerEvents="none"
              value={selectedImgBig}
              onChange={(e) => {
                setSelectedImgBig(e);
                if (e) {
                  handleUploadImage(e, "avatar");
                }
              }}
            />

            <Box
              mt="sm"
              style={{
                border: "2px dashed #e9ecef",
                borderRadius: "8px",
                padding: "12px",
                backgroundColor: "#f8f9fa",
                textAlign: "center",
              }}
            >
              <Text size="xs" c="dimmed" mb="xs">
                Ảnh đại diện hiện tại
              </Text>
              <Box
                style={{
                  borderRadius: "6px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  border: "1px solid #dee2e6",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: 140, // Cố định chiều cao và chiều rộng khung ảnh
                }}
              >
                {previewImgBig ? (
                  <img
                    src={previewImgBig}
                    alt="Preview Big"
                    style={{
                      width: 120,
                      height: 120,
                      objectFit: "cover",
                      display: "block",
                      margin: "auto",
                      cursor: "pointer",
                    }}
                    onDoubleClick={() => {
                      setModalImageUrl(previewImgBig);
                      setModalOpened(true);
                    }}
                  />
                ) : (
                  <ImageShow h={120} w={120} img={"#"} />
                )}
              </Box>
            </Box>
          </Box>
        </Group>
        <Textarea
          label="Khoảng lọc giá: "
          placeholder="Nhập khoảng lọc giá..."
          mt="lg"
          autosize
          minRows={3}
          {...form.getInputProps("priceRange")}
        />
        <Text size="sm" mt="xs" fw={400}>
          (Nhập từng giá cách nhau dấu ;) ví dụ: 300000;800000;1500000 có nghĩa
          là tạo ra 4 khoảng giá cho khách hàng lọc Sản phẩm
        </Text>
        <Text size="sm" fw={400}>
          Đó là: - Dưới 300000, - Từ 300000 đến 800000, - Từ 800000 đến 1500000
          và - Trên 1500000
        </Text>

        <Text size="sm" mt="sm" fw={500}>
          Nhập nội dung
        </Text>
        <Text size="sm" mt="sm" fw={300}>
          Thư viện ảnh Bạn cần tạo danh mục trước khi có thể upload ảnh
        </Text>
        <QuillEditor
          toolbarId="t3"
          setValue={setModalContent}
          onChangeValue={(html: string) => (form.getValues().content = html)}
        />

        <Text size="sm" mt="sm" fw={500}>
          Nội dung cố định
        </Text>
        <QuillEditor
          toolbarId="t4"
          setValue={setModalFixedContent}
          onChangeValue={(html: string) =>
            (form.getValues().fixedContent = html)
          }
        />

        {/* <Text size="sm" mt="sm" fw={500}>
          Nhập nội dung cố định (HTML)
        </Text>
        <Text size="sm" mt="sm" fw={300}>
          Thư viện ảnh Bạn cần tạo danh mục trước khi có thể upload ảnh
        </Text>
        <QuillEditor
          toolbarId="t2"
          setValue={setModel}
          onChangeValue={(html: string) => (form.values.fixedContent = html)}
        /> */}
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label="Thứ tự xuất hiện (cao xếp trước): "
            placeholder="Thứ tự..."
            {...form.getInputProps("orderedNumber")}
            type="number"
          />

          <TextInput
            label="Template File: "
            placeholder="Template File..."
            {...form.getInputProps("templateFile")}
          />
        </Group>

        <Group mb={"lg"} grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label="Redirect tới URL (khi truy cập danh mục sẽ chuyển sang link này): "
            placeholder="URL..."
            {...form.getInputProps("urlRedirect")}
          />

          <TextInput
            label="Số Sản phẩm hiển thị (để = 0 nếu mặc định theo hệ thống cài đặt chung): "
            placeholder="Số Sản phẩm..."
            type="number"
            {...form.getInputProps("visibleItemQty")}
          />
        </Group>
        <Text size="md" mt="lg" fw={500}>
          Dùng cho SEO
        </Text>

        <Group grow wrap="nowrap" mt="xs" gap={"lg"}>
          <Select
            label="Index for SEO	: "
            placeholder="Index..."
            data={[
              { value: "Y", label: "Có" },
              { value: "N", label: "Không" },
            ]}
            {...form.getInputProps("idexForSeo")}
          />
          <TextInput
            label="Link SEO (alias): "
            placeholder="Nhập link SEO thay thế..."
            {...form.getInputProps("linkForSeo")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="xs" gap={"lg"}>
          <Textarea
            label={MetaTitle}
            placeholder="Meta Title..."
            {...form.getInputProps("metaTitle")}
            autosize
            withAsterisk
            onChange={(e) => {
              GetMetaTitle(e.target.value);
              if (form.getInputProps(`metaTitle`).onChange)
                form.getInputProps(`metaTitle`).onChange(e);
            }}
          />
        </Group>
        <Group grow wrap="nowrap" mt="xs" gap={"lg"}>
          <Textarea
            label={MetaKeywords}
            placeholder="Meta Keywords..."
            {...form.getInputProps("metaKeyword")}
            autosize
            withAsterisk
            onChange={(e) => {
              GetMetaKeywords(e.target.value);
              if (form.getInputProps(`metaKeyword`).onChange)
                form.getInputProps(`metaKeyword`).onChange(e);
            }}
            minRows={3}
          />
          <Textarea
            label={MetaDescription}
            placeholder="Meta Description..."
            withAsterisk
            autosize
            minRows={3}
            {...form.getInputProps("metaDescription")}
            onChange={(e) => {
              GetMetaDescription(e.target.value);
              if (form.getInputProps(`metaTitle`).onChange)
                form.getInputProps(`metaDescription`).onChange(e);
            }}
          />
        </Group>
        <Divider my="sm" />
      </Box>
    </>
  );

  return (
    <>
      <Box
        component="form"
        onSubmit={form.onSubmit((e: TblCategoryModel) => {
          handleSubmitForm(e);
        })}
        style={{ position: "relative" }}
      >
        <Tabs defaultValue="info1" style={{ position: "relative" }}>
          <Tabs.List
            style={{
              position: "sticky",
              top: 52,
              zIndex: 1,
              backgroundColor: "white",
            }}
          >
            <Tabs.Tab value="info1">Cơ bản</Tabs.Tab>
            {/* <Tabs.Tab
              value="info2"
              disabled={form.values.idParent ? true : false}
            >
              Ảnh danh mục
            </Tabs.Tab> */}
          </Tabs.List>

          <Tabs.Panel value="info1">{formCreate}</Tabs.Panel>
          {/* <Tabs.Panel value="info2">
            <ListTblCategoryImageView
              dataCategoryImage={form.values.listTblCategoryImage}
              onAddCategoryImage={handleAddCategoryImage}
            />
          </Tabs.Panel> */}
        </Tabs>
        <Group
          justify="center"
          mt="xs"
          p="10px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Tạo danh mục
          </Button>
          <></>
        </Group>
      </Box>

      <Modal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        centered
        size="auto"
        title="Xem ảnh lớn"
        overlayProps={{ zIndex: 999999 }}
        zIndex={999999}
      >
        {modalImageUrl && (
          <img
            src={modalImageUrl}
            alt="Ảnh lớn"
            style={{
              maxWidth: "90vw",
              maxHeight: "80vh",
              zIndex: 999999999,
              display: "block",
              margin: "auto",
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default CreateView;
